import React from 'react'
import style from './grid.mod.scss'
import { graphql } from 'gatsby'

const Grid = ({
  children,
  moduleStyle = 'default',
  template = 'default',
  gridGap
}) => {
  const modifiers = [
    style[
      'grid--' +
        moduleStyle
          .trim()
          .toLowerCase()
          .replace(/ /gi, '-')
    ],
    style[
      'grid--' +
        template
          .trim()
          .toLowerCase()
          .replace(/ /gi, '-')
    ]
  ]

  gridGap && modifiers.push(style[`grid--grid-gap-${gridGap}`])

  return (
    <div className={[style.grid, ...modifiers].join(' ')}>
      <div className={style.grid__wrapper}>{children}</div>
    </div>
  )
}

export default Grid

export const query = graphql`
  fragment CardGrid on DatoCmsCardGrid {
    background
    heading
    padding
    leadNode {
      childMarkdownRemark {
        html
      }
    }
    cards {
      ...Card
    }
    model {
      apiKey
    }
  }

  fragment PostGrid on DatoCmsPostGrid {
    background
    backgroundStyle
    heading
    padding
    leadNode {
      childMarkdownRemark {
        html
      }
    }
    posts {
      ...PostCard
    }
    model {
      apiKey
    }
  }
`
